import { mapGetters, mapActions } from 'vuex'

const moduleName = 'purchaseorders'

export default {
  computed: {
    ...mapGetters(moduleName, {
      returnRoute: 'returnRoute',
      snapshots: 'snapshots',
      baseSnapshot: 'baseSnapshot',
      currentSnapshot: 'currentSnapshot',
      snapshotDiff: 'snapshotDiff',
      readOnlyView: 'readOnlyView',
      isLockPurchaseOrder: 'isLockPurchaseOrder'
    }),
    ...mapGetters('quotes', {
      quoteCustomer: 'quoteCustomer',
      quoteVehicle: 'quoteVehicle',
      quoteInsurer: 'quoteInsurer'
    }),
    ...mapGetters(['licenceExpired'])
  },
  methods: {
    ...mapActions(moduleName, ['getStoreItem', 'addStoreItem', 'saveSnapshot', 'clearSnapshots', 'setReturnRoute', 'setReadOnlyView', 'setLockPurchaseOrder']),
    ...mapActions('quotes', { getQuoteVehicle: 'getQuoteVehicle',getQuoteCustomer: 'getQuoteCustomer', getQuoteInsurer: 'getQuoteInsurer', removeQuoteVehicle: 'removeQuoteVehicle', removeQuoteCustomer: 'removeQuoteCustomer', removeQuoteInsurer: 'removeQuoteInsurer' }),
    ...mapActions('vendors', { setVendorReturnRoute: 'setReturnRoute', addStoreVendor: 'addStoreItem', editStoreVendor: 'editStoreItem' }),
    ...mapActions('contacts', { setContactReturnRoute: 'setReturnRoute', addStoreContact: 'addStoreItem', editStoreContact: 'editStoreItem' }),
    ...mapActions('printpreview', { setPrintPreviewReturnRoute: 'setReturnRoute', addEmailer: 'addEmailer', removeEmailer: 'removeEmailer' }),
    ...mapActions('printpreview', { addReportParameters: 'addParameters', removeReportParameters: 'removeParameters' })
  }
}
